// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  proposalId: __t.u64().primaryKey().name("proposal_id"),
  gameId: __t.u64().name("game_id"),
  tickets: __t.string(),
  quality: __t.f32(),
  accepted: __t.bool(),
  sessionId: __t.u64().name("session_id"),
  at: __t.timestamp(),
});
